module.exports = __webpack_public_path__ + "static/media/summerSchool.16485f16.webp";